import { Asset } from '../models/asset';

export const assets: Asset[] =
    [

        {
            'category': 'Label',
            'name': 'Message avec texte riche',
            'id': 'RICH_TEXT_MESSAGE',
            'icon': 'assets/icons/rich_text_message.svg',
            'iconWizard': ""
        },
        {
            'category': 'Label',
            'name': 'Message de succès',
            'id': 'SUCCESS_MESSAGE',
            'icon': 'assets/icons/success_message.svg',
            'iconWizard': ""
        },
        {
            'category': 'Label',
            'name': 'Message d\'information',
            'id': 'INFORMATION_MESSAGE',
            'icon': 'assets/icons/info_message.svg',
            'iconWizard': ""
        },
        {
            'category': 'Label',
            'name': 'Message d\'alerte',
            'id': 'WARNING_MESSAGE',
            'icon': 'assets/icons/warning_message.svg',
            'iconWizard': ""
        },
        {
            'category': 'Label',
            'name': 'Message d\'erreur',
            'id': 'ERROR_MESSAGE',
            'icon': 'assets/icons/error_message.svg',
            'iconWizard': ""
        },
        {
            'category': 'Label',
            'name': 'Titre 1',
            'id': 'HEADER_1',
            'icon': 'assets/icons/titre1.svg',
            'iconWizard': ""
        },
        {
            'category': 'Label',
            'name': 'Titre 2',
            'id': 'HEADER_2',
            'icon': 'assets/icons/titre2.svg',
            'iconWizard': ""
        },
        {
            'category': 'Label',
            'name': 'Titre 3',
            'id': 'HEADER_3',
            'icon': 'assets/icons/titre3.svg',
            'iconWizard': ""
        },
        {
            'category': 'Label',
            'name': 'Titre 4',
            'id': 'HEADER_4',
            'icon': 'assets/icons/titre4.svg',
            'iconWizard': ""
        },
        {
            'category': 'Label',
            'name': 'Titre 5',
            'id': 'HEADER_5',
            'icon': 'assets/icons/titre5.svg',
            'iconWizard': ""
        },
        {
            'category': 'Label',
            'name': 'Titre 6',
            'id': 'HEADER_6',
            'icon': 'assets/icons/titre6.svg',
            'iconWizard': ""
        },
        {
            'category': 'Input',
            'name': 'Champ de type texte',
            'id': 'TEXT_FIELD',
            'icon': 'assets/icons/champ_texte.svg',
            'iconWizard': 'assets/icons/champ_texte_input.svg'
        },
        {
            'category': 'Input',
            'name': 'Zone de texte',
            'id': 'TEXT_AREA',
            'icon': 'assets/icons/zone_de_texte.svg',
            'iconWizard': 'assets/icons/zone_de_texte_input.svg'
        },
        {
            'category': 'Input',
            'name': 'Champ de type nombre',
            'id': 'INTEGER',
            'icon': 'assets/icons/nombre.svg',
            'iconWizard': 'assets/icons/nombre_input.svg'
        },
        {
            'category': 'Input',
            'name': 'Champ de type date',
            'id': 'DATE',
            'icon': 'assets/icons/date.svg',
            'iconWizard': 'assets/icons/date_input.svg'
        },
        {
            'category': 'Choice',
            'name': 'Bouton radio',
            'id': 'RADIO_BUTTON',
            'icon': 'assets/icons/radio.svg',
            'iconWizard': 'assets/icons/radio_input.svg'
        },
        {
            'category': 'Choice',
            'name': 'Liste de boutons radio verticale',
            'id': 'RADIO_LIST_VERTICAL',
            'icon': 'assets/icons/radio_list_vertical.svg',
            'iconWizard': 'assets/icons/radio_list_vertical_input.svg'
        },
        {
            'category': 'Choice',
            'name': 'Liste de boutons radio horizontale',
            'id': 'RADIO_LIST_HORIZONTAL',
            'icon': 'assets/icons/radio_list_horizontal.svg',
            'iconWizard': 'assets/icons/radio_list_horizontal_input.svg'
        },
        {
            'category': 'Choice',
            'name': 'Case à cocher',
            'id': 'CHECK_BOX',
            'icon': 'assets/icons/checkbox.svg',
            'iconWizard': 'assets/icons/checkbox_input.svg'
        },
        {
            'category': 'Choice',
            'name': 'Liste de valeur',
            'id': 'COMBO_BOX',
            'icon': 'assets/icons/combobox.svg',
            'iconWizard': 'assets/icons/combobox_input.svg'
        },
        {
            'category': 'Group',
            'name': 'Groupe Simple',
            'id': 'CONTAINER',
            'icon': 'assets/icons/groupe.svg',
            'iconWizard': ''
        },
        {
            'category': 'Tool',
            'name': 'Import de photos',
            'id': 'PHOTO_IMPORT',
            'icon': 'assets/icons/import.svg',
            'iconWizard': ''
        }
    ];
